<template>
  <div>
    <el-select
      v-model="currentCate"
      size="small"
      filterable
      placeholder="筛选职能模块"
      style="margin-left:20px;margin-top:5px"
      @change="loadData"
    >
      <el-option v-for="item in cateOptions" :key="item" :label="item" :value="item"></el-option>
    </el-select>
    <el-card v-for="(item, k) in data" :key="item._id" class="box-card">
      <div class="dup-wapper">
        <table class="dup-table" cellspacing="0">
          <tr class="dup-row">
            <td class="dup-col dup-col-num" :rowspan="3">{{ (currentPage - 1) * pageSize + k + 1 }}</td>
            <td class="dup-col">类型</td>
            <td class="dup-col">操作</td>
            <td v-for="head in tableHeads" :key="head.label" class="dup-col">{{ head.label }}</td>
          </tr>
          <tr class="dup-row">
            <td class="dup-col">缓存数据</td>
            <td class="dup-col"><span class="radish-link" @click="updateZhu(item)">更新主职能模块</span></td>
            <td v-for="head in tableHeads" :key="item._id + head.label" class="dup-col" :title="item[head.label]">
              <span>{{ item[head.label] }}</span>
            </td>
          </tr>
          <tr v-if="item.radish" class="dup-row">
            <td class="dup-col">现有数据</td>
            <td class="dup-col"><span class="radish-link" @click="keepZhu(item)">保持主职能模块</span></td>
            <td
              v-for="head in tableHeads"
              :key="item.radish._id + head.label"
              class="dup-col"
              :title="item.radish[head.label]"
            >
              <span v-if="head.label == '姓名'" class="radish-link" @click="clickName(item.radish)">{{
                item.radish[head.label]
              }}</span>
              <span v-else>{{ item.radish[head.label] }}</span>
            </td>
          </tr>
        </table>
      </div>
    </el-card>
    <el-pagination
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="loadData"
    ></el-pagination>
    <el-dialog title="选择主职能模块" top="70px" :close-on-click-modal="false" :modal="false" :visible.sync="dialogVisible">
      <el-select v-model="mainCate" filterable size="mini">
        <el-option v-for="op in currentItem['职能模块']" :key="op" :label="op" :value="op"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="close">取 消</el-button>
        <el-button size="mini" type="primary" @click="mainCateConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableHeads from './constant/table-heads-dup'

export default {
  mixins: [tableHeads],
  data: function() {
    return {
      cateOptions: [],
      mainCateOptions: [],
      currentCate: '',
      mainCate: '',
      currentPage: 1,
      pageSize: 50,
      data: [],
      total: 0,
      dialogVisible: false,
      currentItem: {},
    }
  },
  mounted() {
    this.loadCate()
    this.loadData()
  },
  methods: {
    loadData: async function() {
      const res = await app.service('radish').listTmp({
        page: this.currentPage,
        limit: this.pageSize,
        cate: this.currentCate,
      })
      if (res.status == 'success') {
        this.data = res.data
        this.total = res.total
        // console.log(res)
      }
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        const tmp = catData.map(item => item['名称'])
        const prem = app.user['SL权限']
        const role = app.user['角色']
        let tmp2 = []
        if (!role ||(!role.includes('管理员') && !role.includes('业务助理'))) {
          if (!prem || prem.length == 0) {
            tmp2 = []
          } else {
            const catArr = prem.split(';')
            tmp2 = tmp.filter(c => catArr.includes(c))
          }
        } else {
          tmp2 = JSON.parse(JSON.stringify(tmp))
        }
        this.cateOptions = tmp2
      }
    },
    mainCateConfirm: async function() {
      if (this.mainCate) {
        const dt = { mergeType: '主', 主职能模块: this.mainCate }
        await this.modifyData(this.currentItem._id, dt)
        this.close()
      } else {
        this.$message.error('请选择主职能模块')
      }
    },
    close: function() {
      this.dialogVisible = false
      this.currentItem = {}
      this.mainCate = ''
    },
    updateZhu: async function(item) {
      const n = item
      const tmpId = item._id
      const id = item.radish._id
      const tmpArr = (n['职能模块'] || []).concat(item.radish['职能模块'] || [])
      delete n.radish
      delete n._id
      n['职能模块'] = Array.from(new Set(tmpArr))
      const data = [
        {
          o: { _id: id },
          n: n,
        },
      ]
      const res = await app.service('radish').merge({
        data: data,
        main: 'n',
        isZhiReplace: true,
        from: 'list',
      })
      if (res.status == 'success') {
        const dres = await app.service('radish').deleteTmp({ _id: tmpId })
        if (dres.status == 'success') {
          this.loadData()
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    keepZhu: async function(item) {
      const n = item
      const tmpId = item._id
      const id = item.radish._id
      delete n.radish
      delete n._id
      n['职级'] = ''
      n['业绩'] = ''
      const data = [
        {
          o: { _id: id },
          n: n,
        },
      ]
      const res = await app.service('radish').merge({
        data: data,
        main: 'n',
        from: 'list',
      })
      if (res.status == 'success') {
        const dres = await app.service('radish').deleteTmp({ _id: tmpId })
        if (dres.status == 'success') {
          this.loadData()
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    modifyData: async function(id, data) {
      const res = await app.service('radish').modifyById({ _id: id, data: data })
      if (res.status == 'success') {
        this.loadData()
      } else {
        this.$message.error(res.msg)
      }
    },
    clickName: function(item) {
      window.open(`${window.frontend}/#/radish-detail-blank/${item._id}`, '_blank')
    },
  },
}
</script>
<style>
.dup-wapper {
  overflow: auto;
}
.dup-table {
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  width: 4850px;
  transform: none;
}
.dup-col {
  width: 100px;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  height: 24px;
  line-height: 24px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dup-col.dup-col-num {
  width: 50px;
}
.dup-action {
  padding: 2px;
  background-color: #f5f7fa;
  color: #c0c4cc;
  cursor: pointer;
}
.dup-action.dup-action-active {
  background-color: #409eff;
  color: #fff;
}
</style>
